import React from 'react';

import { preAlertApis } from '@apis/next/preAlertApis';
import { TrackingDataDetails } from '@components/admin/booking/TrackingDataDetails';
import { Layout } from '@components/Layout';
import { PrintableContainer } from '@components/Printable';
import { bookingsStrings } from '@data/bookings';
import { useBookingInquiryDetail } from '@hooks/queries/useBookingInquiryDetail';
import { useSearch } from '@hooks/useSearch';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { formatDateTime } from '@utils/types';
import * as t from 'io-ts';

const useStyles = makeMuiStyles((theme, _common) => ({
  background: {
    backgroundColor: theme.palette.background.paper,
  },
}));

const searchType = t.type({
  d2dNo: t.string,
});

export const PrintCurrentBookingDetails: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const {
    search: { d2dNo },
  } = useSearch(searchType);
  const bookingInquiry = useBookingInquiryDetail(d2dNo);
  const preAlertItem = preAlertApis.useGet('/pre-alert/:d2d_no', {
    params: {
      d2d_no: d2dNo,
    },
  });

  return (
    <Layout
      hideHeader
      hideFooter
      hideCookiePolicy
      loading={bookingInquiry.isLoading || preAlertItem.isLoading}
      title={bookingsStrings.currentBookings}
      errors={[bookingInquiry.error]}
      classes={{
        background: classes.background,
      }}
    >
      <PrintableContainer>
        <p className={classes.horizontalSpace1}>
          <span>Latest Update:</span>
          <span>
            {bookingInquiry.data?.updated_at == null
              ? ''
              : formatDateTime(bookingInquiry.data?.updated_at)}
          </span>
        </p>
        {bookingInquiry.data?.d2d_no && preAlertItem.data && (
          <TrackingDataDetails
            bookingId={bookingInquiry.data?.id}
            d2dNo={bookingInquiry.data?.d2d_no}
            preAlert={preAlertItem.data}
            isClient
          />
        )}
      </PrintableContainer>
    </Layout>
  );
};
